import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_ICDS_REQUEST, fetchIcdsSuccess, fetchIcdsFailure,
  CREATE_ICD_REQUEST, createIcdSuccess, createIcdFailure,
  UPDATE_ICD_REQUEST, updateIcdSuccess, updateIcdFailure,
  DELETE_ICD_REQUEST, deleteIcdSuccess, deleteIcdFailure,
  FETCH_ICD_RULES_REQUEST, fetchIcdRulesSuccess, fetchIcdRulesFailure,
  MAP_ICD_TO_RULE_REQUEST, mapIcdToRuleSuccess, mapIcdToRuleFailure,
  DELETE_ICD_RULE_MAPPING_REQUEST, deleteIcdRuleMappingSuccess, deleteIcdRuleMappingFailure
} from '../actions/icdActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchIcds(action) {

  try {
    const token = getAuthToken();
    const {  page = 1, limit = 2, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching ICD with payload: ", action.payload);

    // const response = yield call(axios.get, `${API_BASE_URL}/icd`, createConfig());
    const response = yield call(
      axios.get,
      `${getBaseUrl()}/icd`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit },
      }
    );
    yield put(fetchIcdsSuccess(response.data));
  } catch (error) {
    yield put(fetchIcdsFailure(error.message));
  }
}

function* createIcd(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/icd`, action.payload, createConfig());
    yield put(createIcdSuccess(response.data));
  } catch (error) {
    yield put(createIcdFailure(error.message));
  }
}

function* updateIcd(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/icd/${id}`, data, createConfig());
    yield put(updateIcdSuccess(response.data));
  } catch (error) {
    yield put(updateIcdFailure(error.message));
  }
}

function* deleteIcd(action) {
  try {
    yield call(axios.delete, `${API_BASE_URL}/icd/${action.payload}`, createConfig());
    yield put(deleteIcdSuccess(action.payload));
  } catch (error) {
    yield put(deleteIcdFailure(error.message));
  }
}

function* fetchIcdRules(action) {
  try {
    const { projectId, icdId } = action.payload;
    const response = yield call(axios.get, `${API_BASE_URL}/icd/${projectId}/${icdId}/rules`, createConfig());
    yield put(fetchIcdRulesSuccess(response.data));
  } catch (error) {
    yield put(fetchIcdRulesFailure(error.message));
  }
}

function* mapIcdToRule(action) {
  try {
    const { projectId, icdId, ruleId } = action.payload;
    yield call(axios.put, `${API_BASE_URL}/icd/${projectId}/${icdId}/rules/${ruleId}`, {}, createConfig());
    yield put(mapIcdToRuleSuccess());
  } catch (error) {
    yield put(mapIcdToRuleFailure(error.message));
  }
}

function* deleteIcdRuleMapping(action) {
  try {
    const { projectId, icdId, ruleId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/icd/${projectId}/${icdId}/rules/${ruleId}`, createConfig());
    yield put(deleteIcdRuleMappingSuccess());
  } catch (error) {
    yield put(deleteIcdRuleMappingFailure(error.message));
  }
}

export default function* icdSaga() {
  yield takeLatest(FETCH_ICDS_REQUEST, fetchIcds);
  yield takeLatest(CREATE_ICD_REQUEST, createIcd);
  yield takeLatest(UPDATE_ICD_REQUEST, updateIcd);
  yield takeLatest(DELETE_ICD_REQUEST, deleteIcd);
  yield takeLatest(FETCH_ICD_RULES_REQUEST, fetchIcdRules);
  yield takeLatest(MAP_ICD_TO_RULE_REQUEST, mapIcdToRule);
  yield takeLatest(DELETE_ICD_RULE_MAPPING_REQUEST, deleteIcdRuleMapping);
}
